import { pathLens, RecursiveRequired, ValueBind } from "./ControlLenses";
import { extractPath, extractTokens } from "./PathHelper";

export interface ValueBindWithInfo<T> extends ValueBind<T> {
    pathTokens: string[];
}

export class LensFactory<T> implements ValueBind<T> {
    public readonly value: T;
    public readonly onValueChange: (value: T) => void;

    public constructor(value: T, onChange: (value: T) => void) {
        this.value = value;
        this.onValueChange = onChange;
    }

    public to<TR>(propSelector: (input: RecursiveRequired<T>) => TR): ValueBindWithInfo<TR> {
        const pathTokens = extractTokens(extractPath(propSelector.toString()));
        return {
            ...pathLens({ value: this.value, onValueChange: this.onValueChange }, propSelector),
            pathTokens: pathTokens,
        };
    }

    public current(): ValueBind<T> {
        return {
            value: this.value,
            onValueChange: this.onValueChange,
        };
    }
}

export function useLensFactory<T>(value: T, onChange: (nextValue: T) => void): LensFactory<T> {
    return new LensFactory<T>(value, onChange);
}
